var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page-tab queryWriteOff" },
    [
      _c(
        "write-off-search",
        {
          ref: "searchItem",
          attrs: {
            "is-append-query": true,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
            "config-module": "509",
            "grid-config-module": "190706",
            ar: _vm.ar,
            "is-bank-slip": 0,
            oversea: _vm.oversea,
            "verf-date": _vm.verfDate,
            "pre-query": _vm.preQuery,
            "input-date-start": _vm.searchConditions.startDate,
            "input-date-end": _vm.searchConditions.endDate,
            "show-controlled-charge": false,
            "show-bill-payment-detail": true,
            "show-invoice-detail": true,
            "show-fba": false,
            "show-wht": true,
            "view-source": "tabWriteOffList"
          },
          on: {
            queryResultCallBack: function(data) {
              return (_vm.rowData = data)
            },
            clickedCallBack: function(row) {
              return (_vm.clickRow = row)
            },
            doubleClickedCallBack: _vm.doubleClickedCallBack
          },
          scopedSlots: _vm._u([
            {
              key: "searchAreaHeader",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "app-main-inner-row  extension-conditions-form"
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: true, "label-position": "left" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: { label: _vm.$t("WriteOff.writeOffType") }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "11" },
                                  model: {
                                    value: _vm.oversea,
                                    callback: function($$v) {
                                      _vm.oversea = $$v
                                    },
                                    expression: "oversea"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: -1 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.all")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.domestic")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("WriteOff.international"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: {
                                label: _vm.$t(
                                  "WriteOff.revenueAndExpenditureMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "12" },
                                  model: {
                                    value: _vm.ar,
                                    callback: function($$v) {
                                      _vm.ar = $$v
                                    },
                                    expression: "ar"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: -1 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.all")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("WriteOff.receivables"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.payables")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: { label: _vm.$t("WriteOff.writeOffDate") }
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "date",
                                              no: "13",
                                              clearable: false,
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.pickerOptions,
                                              editable: false
                                            },
                                            on: { change: _vm.exchangeDate },
                                            model: {
                                              value:
                                                _vm.searchConditions.startDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.searchConditions,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchConditions.startDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("WriteOff.dateTo")))
                                    ])
                                  ]),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "date",
                                              no: "14",
                                              clearable: "",
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.pickerOptions
                                            },
                                            on: { change: _vm.exchangeDate },
                                            model: {
                                              value:
                                                _vm.searchConditions.endDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.searchConditions,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchConditions.endDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                id: "lockConditions",
                                                no: "15"
                                              },
                                              model: {
                                                value: _vm.allowTwoYearOutside,
                                                callback: function($$v) {
                                                  _vm.allowTwoYearOutside = $$v
                                                },
                                                expression:
                                                  "allowTwoYearOutside"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "WriteOff.queryLotsOfData"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_ACWriteoff_approve"],
                      expression: "['button_ACWriteoff_approve']"
                    }
                  ],
                  attrs: { type: "primary", no: "1" },
                  on: {
                    click: function($event) {
                      return _vm.approveHandler(null)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.recheck")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_ACWriteoff_approve"],
                      expression: "['button_ACWriteoff_approve']"
                    }
                  ],
                  attrs: { type: "primary", no: "2" },
                  on: { click: _vm.unapproveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.cancelRecheck")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: [
                        "role_ACWriteoff_modifyWriteoff",
                        "button_ACWriteoff_modifyWriteoff"
                      ],
                      expression:
                        "['role_ACWriteoff_modifyWriteoff', 'button_ACWriteoff_modifyWriteoff']"
                    }
                  ],
                  attrs: {
                    type: "primary",
                    no: "3",
                    disabled: _vm.clickRow === null
                  },
                  on: { click: _vm.editWriteoffHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.editWriteOff")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: [
                        "button_ACWriteoff_cancelWriteOff",
                        "button_ACWriteoff_cancelOtherWriteOff"
                      ],
                      expression:
                        "['button_ACWriteoff_cancelWriteOff', 'button_ACWriteoff_cancelOtherWriteOff']"
                    }
                  ],
                  attrs: {
                    type: "primary",
                    disabled: _vm.clickRow === null || _vm.isExecuting,
                    no: "4"
                  },
                  on: { click: _vm.cancelWriteoffHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.cancelWriteOff")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.clickRow === null,
                    no: "5"
                  },
                  on: { click: _vm.showDetailHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.viewDetails")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "6" },
                  on: { click: _vm.exportHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.exportExcel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "7" },
                  on: { click: _vm.viewAccountingDocumentClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.proof")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.refreshRate,
                      expression: "refreshRate"
                    }
                  ],
                  attrs: { type: "primary", no: "8" },
                  on: { click: _vm.refreshRateHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.refreshRate")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.refreshRate,
                      expression: "refreshRate"
                    }
                  ],
                  attrs: { type: "primary", no: "9" },
                  on: { click: _vm.refreshPaymentHandler }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("WriteOff.refreshActualReceiptAndPaymentAmount")
                    )
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.clickRow === null,
                    no: "10"
                  },
                  on: { click: _vm.btnPrintHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.print")))]
              ),
              ((_vm.jydToFinanceApi && _vm.oversea === 0) ||
                _vm.qlToFinanceApi) &&
              _vm.$checkPermission(["button_ACWriteoff_syncCloud"])
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "syncVerifyDoc" },
                      on: { click: _vm.syncCloudPlatform }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SyncVerifyDoc")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "exportUndoHistory" },
                  on: { click: _vm.exportUndoHistoryHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExportUndoHistory")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.editDialog.show
        ? _c("edit-writeoff-dialog", {
            attrs: {
              visible: _vm.editDialog.show,
              params: _vm.editDialog.params,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editDialog, "show", $event)
              },
              successCallBack: _vm.refreshRow
            }
          })
        : _vm._e(),
      _c("write-off-detail-dialog", {
        attrs: {
          visible: _vm.detailDialog.visible,
          params: _vm.detailDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.detailDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            attrs: {
              visible: _vm.accountingEntryWindow.visible,
              "is-ext": _vm.isExt,
              "prefix-data-provider":
                _vm.accountingEntryWindow.prefixDataProvider,
              "account-title-data-provider":
                _vm.accountingEntryWindow.accountTitleDataProvider,
              "mapping-departments":
                _vm.accountingEntryWindow.mappingDepartments,
              "mapping-staffs": _vm.accountingEntryWindow.mappingStaffs,
              voucher: _vm.accountingEntryWindow.rowData,
              index: _vm.accountingEntryWindow.index,
              "account-set": _vm.accountingEntryWindow.accountSet,
              check: _vm.activeEditVoucherVerification,
              "check-department": _vm.checkDepartmentAccountingItem
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              }
            }
          })
        : _vm._e(),
      _vm.dateSelecterDialog.visible
        ? _c("date-selector", {
            ref: "dateSelecter",
            attrs: {
              "account-set": null,
              visible: _vm.dateSelecterDialog.visible,
              "current-state": _vm.dateSelecterDialog.currentState,
              "biz-data-type": _vm.dateSelecterDialog.bizDataType,
              source: _vm.dateSelecterDialog.source,
              "non-group-data": _vm.dateSelecterDialog.nonGroupData,
              "show-account-set-select":
                _vm.dateSelecterDialog.showAccountSetSelect,
              "office-id": _vm.dateSelecterDialog.officeId,
              "generate-type": "commit"
            },
            on: {
              select: _vm.selectDataHandler,
              groupCommit: _vm.selectDataHandler,
              cancel: function() {
                return (_vm.dateSelecterDialog.visible = false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }